import { jsx, jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { noop } from "lodash-es";
import { Button, Menu, Classes, Popover, Switch } from "@blueprintjs/core";
import InfoHelper from "../InfoHelper";
import DraggableColumnOptions from "./DraggableColumnOptions";
import { dragNoticeEl } from "./dragNoticeEl";
const DisplayOptions = ({
  compact,
  extraCompact,
  disabled,
  doNotSearchHiddenColumns,
  hideDisplayOptionsIcon,
  resetDefaultVisibility = noop,
  updateColumnVisibility = noop,
  updateTableDisplayDensity,
  moveColumnPersist = noop,
  showForcedHiddenColumns,
  setShowForcedHidden,
  hasOptionForForcedHidden,
  schema
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const changeTableDensity = (e) => {
    updateTableDisplayDensity(e.target.value);
    setIsOpen(false);
  };
  const toggleForcedHidden = (e) => setShowForcedHidden(e.target.checked);
  if (hideDisplayOptionsIcon) {
    return null;
  }
  const { fields } = schema;
  let numVisible = 0;
  fields.forEach((field) => {
    if (!field.isHidden && field.type !== "action") numVisible++;
  });
  return /* @__PURE__ */ jsx(
    Popover,
    {
      isOpen,
      onClose: () => setIsOpen(false),
      content: /* @__PURE__ */ jsx(Menu, { children: /* @__PURE__ */ jsxs("div", { style: { padding: 10, paddingLeft: 20, paddingRight: 20 }, children: [
        /* @__PURE__ */ jsx("h5", { style: { marginBottom: 10, fontWeight: "bold" }, children: "Display Density:" }),
        /* @__PURE__ */ jsx("div", { className: Classes.SELECT + " tg-table-display-density", children: /* @__PURE__ */ jsxs(
          "select",
          {
            onChange: changeTableDensity,
            value: extraCompact ? "extraCompact" : compact ? "compact" : "normal",
            children: [
              /* @__PURE__ */ jsx("option", { className: Classes.POPOVER_DISMISS, value: "normal", children: "Comfortable" }),
              /* @__PURE__ */ jsx("option", { className: Classes.POPOVER_DISMISS, value: "compact", children: "Normal" }),
              /* @__PURE__ */ jsx(
                "option",
                {
                  className: Classes.POPOVER_DISMISS,
                  value: "extraCompact",
                  children: "Compact"
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs(
          "h5",
          {
            style: {
              fontWeight: "bold",
              marginBottom: 0,
              marginTop: 10,
              display: "flex"
            },
            children: [
              "Displayed Columns: \xA0",
              doNotSearchHiddenColumns && /* @__PURE__ */ jsx(InfoHelper, { children: "Note: Hidden columns will NOT be used when searching the datatable" })
            ]
          }
        ),
        dragNoticeEl,
        /* @__PURE__ */ jsx("div", { style: { maxHeight: 360, overflowY: "auto", padding: 2 }, children: /* @__PURE__ */ jsx(
          DraggableColumnOptions,
          {
            fields,
            onVisibilityChange: updateColumnVisibility,
            moveColumnPersist,
            numVisible
          }
        ) }),
        hasOptionForForcedHidden && /* @__PURE__ */ jsx("div", { style: { marginTop: 15 }, children: /* @__PURE__ */ jsx(
          Switch,
          {
            label: "Show Empty Columns",
            checked: showForcedHiddenColumns,
            onChange: toggleForcedHidden
          }
        ) }),
        /* @__PURE__ */ jsx(
          Button,
          {
            style: { marginTop: 5 },
            onClick: resetDefaultVisibility,
            title: "Display Options",
            icon: "reset",
            minimal: true,
            children: "Reset Column Visibilites"
          }
        )
      ] }) }),
      children: /* @__PURE__ */ jsx(
        Button,
        {
          className: "tg-table-display-options",
          onClick: () => setIsOpen(true),
          disabled,
          minimal: true,
          icon: "cog"
        }
      )
    }
  );
};
export default DisplayOptions;
